if (!window.cyseekinGiftCartOrder) {
  window.cyseekinGiftCartOrder = {
    groups: [
      ['S10 Gratis-Zubehör freischalten', ['cyseekin-s10']],
      ['S10 2er-Set mit Gratis-Zubehör', ['cyseekin-s10-2er-set']],
      ['C10 Gratis-Zubehör freischalten', ['c10', 'c10-falt-e-bike-20-zoll']],
      ['C10 2er-Set mit Gratis-Zubehör', ['c10-2er-set-falt-e-bike']],
      ['C20 Gratis-Zubehör freischalten', ['c20-falt-e-bike-mit-tiefeinsteiger']],
      ['C20 Mini Cargo Gratis-Zubehör', ['c20-semi-cargo-e-bike']],
      ['C20 2er-Set mit Gratis-Zubehör', ['c20-falt-e-bike-2er-set']]
    ],
    scheduled: false,
    observer: null,

    applyList(list) {
      this.groups.forEach(([marker, handles]) => {
        const items = Array.from(list.children);
        const gifts = items.filter((item) => item.textContent.includes(marker));
        const mains = items.filter((item) => {
          if (handles.includes(item.dataset.handle)) return true;

          const productLink = item.querySelector('a[href*="/products/"]');
          if (!productLink) return false;

          const match = productLink.getAttribute('href').match(/\/products\/([^?/#]+)/);
          return match ? handles.includes(match[1]) : false;
        });
        if (gifts.length === 0 || mains.length === 0) return;

        const firstGift = gifts[0];
        const giftIndex = items.indexOf(firstGift);
        if (mains.every((item) => items.indexOf(item) < giftIndex)) return;

        const fragment = document.createDocumentFragment();
        fragment.append(...mains);
        list.insertBefore(fragment, firstGift);
      });
    },

    apply() {
      const lists = [
        document.querySelector('#CartDrawer cart-items .horizontal-products'),
        document.querySelector('form#cart cart-items table tbody')
      ].filter(Boolean);

      lists.forEach((list) => this.applyList(list));
    },

    schedule() {
      if (this.scheduled) return;
      this.scheduled = true;
      requestAnimationFrame(() => {
        this.scheduled = false;
        this.apply();
      });
    },

    init() {
      const roots = [
        document.querySelector('#CartDrawer [id^="MiniCart-"]'),
        document.querySelector('form#cart cart-items')
      ].filter(Boolean);

      if (roots.length === 0) return;

      this.observer = new MutationObserver(() => this.schedule());
      roots.forEach((root) => this.observer.observe(root, { childList: true, subtree: true }));
      this.apply();
    }
  };

  window.cyseekinGiftCartOrder.init();
}

window.cyseekinGiftCartOrderBuild = '20260916-v01';
